type P = { className?: string }

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

// ── Platform icons ────────────────────────────────────────────────────────────

export function IconInstagram({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      fillRule="evenodd"
      className={className}
      aria-hidden="true"
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  )
}

export function IconTelegram({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      fillRule="evenodd"
      className={className}
      aria-hidden="true"
    >
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  )
}

export function IconWhatsApp({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      fillRule="evenodd"
      className={className}
      aria-hidden="true"
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884z" />
    </svg>
  )
}

export function IconYouTube({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      fillRule="evenodd"
      className={className}
      aria-hidden="true"
    >
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  )
}

export function IconPlay({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <polygon points="10 8 16 12 10 16 10 8" fill="currentColor" stroke="none" />
    </svg>
  )
}

export function IconStar({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M12 2L9.09 8.26 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-1.18-6.86L22 9.27l-7.09-1.01L12 2z" />
    </svg>
  )
}

export function IconBubble({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  )
}

export function IconZap({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  )
}

export function IconShield({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  )
}

export function IconGlobe({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  )
}

// ── Contact icons ─────────────────────────────────────────────────────────────

export function IconMail({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m2 7 10 6 10-6" />
    </svg>
  )
}

export function IconPhone({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  )
}

export function IconPin({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M12 22s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12Z" />
      <circle cx="12" cy="10" r="2.6" />
    </svg>
  )
}

// ── Creator category icons ────────────────────────────────────────────────────

export function IconFashion({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M9 2h6M9 2 6 7H2l5 5v10h10V12l5-5h-4L15 2" />
      <path d="M9 2c.8 2 1.5 3 3 3s2.2-1 3-3" />
    </svg>
  )
}

export function IconFood({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M6 7h12v2a6 6 0 0 1-12 0V7z" />
      <path d="M10 7V4M12 7V3M14 7V4" />
      <path d="M9 15v5M15 15v5M9 20h6" />
    </svg>
  )
}

export function IconTravel({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M22 16.5V15l-9-5V3.5a1.5 1.5 0 0 0-3 0V10l-9 5v1.5l9-2.5V17l-2 1.5V20l3.5-1 3.5 1v-1.5L13 17v-3.5l9 2z" />
    </svg>
  )
}

export function IconTech({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <rect x="7" y="2" width="10" height="20" rx="2" />
      <path d="M11 18h2" />
      <path d="M7 6h10" />
    </svg>
  )
}

export function IconSports({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M6.5 8v8M17.5 8v8" />
      <rect x="2" y="9.5" width="4.5" height="5" rx="1" />
      <rect x="17.5" y="9.5" width="4.5" height="5" rx="1" />
      <rect x="6.5" y="11" width="11" height="2" rx="0.5" />
    </svg>
  )
}

export function IconEducation({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </svg>
  )
}

export function IconEntertainment({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <rect x="2" y="6" width="20" height="16" rx="2" />
      <path d="M2 10h20" />
      <path d="M7 6 5 2M12 6l-1-4M17 6l-2-4" />
    </svg>
  )
}

export function IconMommy({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <circle cx="12" cy="9" r="3" />
      <path d="M4 20v-1a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v1" />
      <path d="M8 14s1 2 4 2 4-2 4-2" />
    </svg>
  )
}

export function IconMusic({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </svg>
  )
}

export function IconBeauty({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <path d="M14 2h-4l-2 6h8L14 2z" />
      <rect x="8" y="8" width="8" height="10" rx="1" />
      <path d="M8 13h8" />
    </svg>
  )
}

export function IconFinance({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  )
}

export function IconPets({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" className={className} {...stroke} aria-hidden="true">
      <circle cx="9" cy="5" r="2" />
      <circle cx="15" cy="5" r="2" />
      <circle cx="4" cy="12" r="2" />
      <circle cx="20" cy="12" r="2" />
      <path d="M12 22c-4 0-6-2.5-6-5.5 0-1 .4-2 1-2.5.5-.5 1.5-1 2-1h6c.5 0 1.5.5 2 1 .6.5 1 1.5 1 2.5 0 3-2 5.5-6 5.5z" />
    </svg>
  )
}

// ── Iranian messenger brand marks ─────────────────────────────────────────────

// Real Bale brand mark — speech bubble with checkmark (glyph extracted from public/platforms/bale.svg)
export function IconBale({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M13.7 0.1C13.7 0.1 13.6 0.1 13.6 0.1 13.5 0.1 13.3 0.1 13.1 0.1 13 0 13 0 12.9 0 12.8 0 12.6 0 12.5 0 12.4 0 12.3 0 12.2 0 12.2 0 12.1 0 12 0 12 0 11.9 0 11.9 0 11.9 0 11.8 0 11.8 0 11.8 0 11.7 0 11.7 0 11.6 0 11.5 0 11.4 0 11.3 0 11.3 0 11.2 0 11.1 0 11 0 10.9 0 10.9 0.1 10.8 0.1 10.7 0.1 10.6 0.1 10.6 0.1 10.5 0.1 10.4 0.1 10.3 0.1 10.2 0.1 10.2 0.1 10.1 0.2 10 0.2 9.9 0.2 9.8 0.2 9.8 0.2 9.7 0.2 9.6 0.2 9.5 0.3 9.5 0.3 9.4 0.3 9.3 0.3 9.2 0.3 9.2 0.3 9.1 0.4 9 0.4 8.9 0.4 8.9 0.4 8.8 0.4 8.7 0.5 8.6 0.5 8.6 0.5 8.5 0.5 8.4 0.5 8.3 0.6 8.3 0.6 8.2 0.6 8.1 0.6 8 0.7 8 0.7 7.9 0.7 7.8 0.7 7.8 0.8 7.7 0.8 7.6 0.8 7.5 0.9 7.5 0.9 7.4 0.9 7.3 0.9 7.3 1 7.2 1 7.1 1 7.1 1.1 7 1.1 6.9 1.1 6.9 1.2 6.8 1.2 6.7 1.2 6.6 1.3 6.6 1.3 6.5 1.3 6.4 1.4 6.4 1.4 6.3 1.4 6.2 1.5 6.2 1.5 6.1 1.5 6 1.6 6 1.6 5.9 1.7 5.8 1.7 5.8 1.7 5.7 1.8 5.6 1.8 5.6 1.9 5.5 1.9 5.4 2 5 2.3 5 2.3 5 2.3 2.8 0.6 1.9 0.2 1-0.3 0 0.3 0 1.3V3.5 11.8C0 11.8 0 11.9 0 12 0 18.4 5 23.6 11.2 24 11.2 24 11.3 24 11.3 24 11.4 24 11.6 24 11.7 24 11.8 24 11.8 24 11.9 24 11.9 24 11.9 24 12 24 12 24 12 24 12 24 12.1 24 12.2 24 12.3 24 12.4 24 12.5 24 12.6 24 12.7 24 12.8 24 12.9 24 13 24 13.1 24 13.2 23.9 13.3 23.9 13.4 23.9 13.5 23.9 13.6 23.9 13.7 23.9 13.8 23.9 13.9 23.9 14 23.8 14.1 23.8 14.2 23.8 14.3 23.8 14.4 23.8 14.5 23.7 14.6 23.7 14.7 23.7 14.8 23.7 14.9 23.7 15 23.6 15.1 23.6 15.2 23.6 15.3 23.5 15.3 23.5 15.4 23.5 15.5 23.5 15.6 23.4 15.7 23.4 15.8 23.4 15.9 23.3 16 23.3 16.1 23.3 16.2 23.2 16.3 23.2 16.4 23.2 16.5 23.1 16.6 23.1 16.6 23.1 16.7 23 16.8 23 16.9 22.9 17 22.9 17.1 22.9 17.2 22.8 17.3 22.8 17.4 22.7 17.4 22.7 17.5 22.7 17.6 22.6 17.7 22.6 17.8 22.5 17.9 22.5 18 22.4 18 22.4 18.1 22.3 18.2 22.3 18.3 22.2 18.4 22.2 18.4 22.1 18.5 22.1 18.6 22 18.7 22 18.8 21.9 18.8 21.9 18.9 21.8 19 21.7 19.1 21.7 19.2 21.6 19.2 21.6 19.3 21.5 19.4 21.5 19.5 21.4 19.5 21.3 19.6 21.3 19.7 21.2 19.8 21.1 19.8 21.1 19.9 21 20 21 20.1 20.9 20.1 20.8 20.2 20.8 20.3 20.7 20.3 20.6 20.4 20.6 20.5 20.5 20.5 20.4 20.6 20.4 20.7 20.3 20.7 20.2 20.8 20.2 20.9 20.1 20.9 20 21 19.9 21.1 19.9 21.1 19.8 21.2 19.7 21.2 19.6 21.3 19.6 21.4 19.5 21.4 19.4 21.5 19.3 21.5 19.3 21.6 19.2 21.7 19.1 21.7 19 21.8 19 21.8 18.9 21.9 18.8 21.9 18.7 22 18.6 22 18.6 22.1 18.5 22.2 18.4 22.2 18.3 22.3 18.2 22.3 18.2 22.4 18.1 22.4 18 22.5 17.9 22.5 17.8 22.5 17.7 22.6 17.6 22.6 17.6 22.7 17.5 22.7 17.4 22.8 17.3 22.8 17.2 22.9 17.1 22.9 17 22.9 16.9 23 16.8 23 16.8 23.1 16.7 23.1 16.6 23.1 16.5 23.2 16.4 23.2 16.3 23.2 16.2 23.3 16.1 23.3 16 23.3 15.9 23.4 15.8 23.4 15.7 23.4 15.7 23.5 15.6 23.5 15.5 23.5 15.4 23.5 15.3 23.6 15.2 23.6 15.1 23.6 15 23.6 14.9 23.7 14.8 23.7 14.7 23.7 14.6 23.7 14.5 23.8 14.4 23.8 14.3 23.8 14.2 23.8 14.1 23.8 14 23.8 13.9 23.9 13.8 23.9 13.7 23.9 13.6 23.9 13.5 23.9 13.4 23.9 13.3 23.9 13.2 24 13.1 24 13 24 12.8 24 12.8 24 12.7 24 12.6 24 12.4 24 12.2 24 12 24 12 24 12 24 12 24 5.9 19.5 0.9 13.7 0.1ZM19 10.5L12 17.4C11.6 17.9 11 18.1 10.4 18.1 9.8 18.1 9.2 17.9 8.7 17.4L5 13.7C4.1 12.8 4.1 11.3 5 10.4 5.9 9.5 7.4 9.5 8.3 10.4L10.4 12.5 15.7 7.2C16.6 6.2 18.1 6.2 19 7.2 19.9 8.1 19.9 9.6 19 10.5Z" />
    </svg>
  )
}

// Rubika brand mark — exact facet geometry from public/platforms/rubika.svg,
// monochrome: dark facets filled, the light center-cube facets left as holes.
export function IconRubika({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      fillRule="evenodd"
      className={className}
      aria-hidden="true"
    >
      <path d="M11.93 0h0.08c0.02 1.89-0.01 5.68-0.01 5.68-1.81-1.01-3.62-2-5.43-3.02q1.77-1.01 3.55-2.01c0.56-0.32 1.16-0.59 1.81-0.65ZM12 0h0.13C12.84 0.06 13.47 0.4 14.08 0.74Q15.77 1.69 17.45 2.65c-1.81 1-3.64 2.03-5.46 3.03-0.02-1.89 0.03-3.79 0.01-5.68ZM6.57 2.66L12 5.67 6.53 8.87s0-2.03 0-3.04C6.53 4.78 6.57 2.66 6.57 2.66ZM17.46 2.65l0.01 0.01c0 1.88 0 3.76 0 5.65 0 0.18 0 0.56 0 0.56L12 5.68S15.65 3.66 17.46 2.65ZM17.47 2.66c1.21 0.69 2.4 1.39 3.6 2.09 0.58 0.33 1.19 0.69 1.51 1.29-1.7 0.94-5.11 2.83-5.11 2.83s0-0.38 0-0.56q0-2.82 0-5.65ZM3.11 4.64c1.13-0.66 3.46-1.98 3.45-1.98L6.53 8.87S3.13 6.99 1.44 6.05C1.81 5.4 2.47 5 3.11 4.64ZM1.05 8.53C1.06 7.7 1.04 6.81 1.44 6.05 3.13 6.99 6.53 8.87 6.53 8.87 4.7 9.93 2.88 11 1.05 12.06 1.05 10.88 1.05 9.71 1.05 8.53ZM22.58 6.04c0.33 0.62 0.38 1.35 0.36 2.05v3.98L17.47 8.87S20.88 6.98 22.58 6.04ZM1.05 12.06c1.83-1.06 3.65-2.13 5.48-3.19q0 3.11 0 6.21c-0.28-0.12-0.54-0.28-0.81-0.43C4.17 13.8 2.62 12.92 1.05 12.07v-0.01ZM17.47 8.87s5.47 3.19 5.47 3.2c-1.82 1.01-5.47 3.03-5.47 3.03h0c0.02-0.81-0.01-1.61 0-2.42V8.87ZM1.05 12.07c1.56 0.85 3.11 1.72 4.67 2.59 0.27 0.14 0.52 0.31 0.81 0.42l0 0.02Q4.01 16.56 1.5 18.03C1.32 17.77 1.23 17.45 1.17 17.14 1.06 16.62 1.05 16.09 1.05 15.56v-3.49ZM22.94 12.07c0 1.22 0 2.44 0 3.66 0.02 0.78-0.01 1.62-0.42 2.31-1.51-0.88-5.05-2.94-5.05-2.94S21.12 13.08 22.94 12.07ZM1.5 18.03Q4.01 16.56 6.53 15.09c-0.01 2.07 0 4.14 0 6.21q-1.78-1.01-3.56-2.02C2.42 18.95 1.85 18.59 1.5 18.03ZM6.53 15.09c1.82 1.01 3.64 2.02 5.47 3.03-1.82 1.06-5.47 3.18-5.47 3.18 0.01-2.07 0-4.14 0-6.21ZM17.46 15.1l0.01 0c0.01 2.07-0.01 4.14 0.01 6.21l-0.02 0.01c-1.44-0.86-2.9-1.7-4.35-2.55-0.37-0.21-1.11-0.65-1.11-0.65S15.64 16.1 17.46 15.1ZM17.47 15.1h0c0.16 0.11 3.54 2.06 5.05 2.94-0.21 0.37-0.56 0.64-0.9 0.88-0.55 0.37-1.14 0.68-1.72 1.02-0.81 0.46-1.61 0.92-2.42 1.37-0.02-2.07 0-4.14-0.01-6.21ZM12 18.12V24c-0.45-0.07-0.95-0.17-1.35-0.4C9.27 22.83 7.9 22.08 6.53 21.3 8.35 20.24 10.17 19.19 12 18.12ZM12 18.12s0.75 0.44 1.11 0.65c1.45 0.85 2.91 1.69 4.35 2.55q-2.11 1.17-4.22 2.34A2.76 2.76 0 0 1 12.1 24h-0.1Z" />
    </svg>
  )
}

// Soroush+ brand mark — squircle speech-bubble with S-curl cutout (silhouette of brand mark)
export function IconSoroush({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      fillRule="evenodd"
      className={className}
      aria-hidden="true"
    >
      <path d="M23.58 13.47A11.19 11.19 0 0 1 22.78 16.29c-0.71 1.69-1.85 3.2-3.26 4.38 0.01 1.05 0.03 2.1-0.01 3.15a1.85 1.85 0 0 1-0.11 0.18h-0.19C18.29 23.52 17.38 23 16.46 22.52c-2.11 0.88-4.49 1.1-6.73 0.66A11.68 11.68 0 0 1 0.42 13.52c-0.14-0.89-0.17-1.79-0.11-2.68 0.05-0.54 0.12-1.08 0.24-1.62a10.65 10.65 0 0 1 0.59-1.92 10.57 10.57 0 0 1 0.89-1.74c0.47-0.78 1.06-1.5 1.7-2.15a10.9 10.9 0 0 1 0.92-0.82A11.62 11.62 0 0 1 10.79 0.07C10.97 0.05 11.16 0.03 11.35 0h1.33c0.57 0.08 1.14 0.11 1.69 0.25a10.3 10.3 0 0 1 1.65 0.46c0.6 0.2 1.17 0.48 1.71 0.79A11.78 11.78 0 0 1 21.11 4.34a11.76 11.76 0 0 1 1.37 2.12A10.87 10.87 0 0 1 23.23 8.38a10.94 10.94 0 0 1 0.41 2.02A11.6 11.6 0 0 1 23.58 13.47ZM10.47 5.92c0.97-1.09 2.43-1.74 3.9-1.61 0.01 0.01 0.04 0.03 0.05 0.04-0.7 0.53-1.07 1.5-0.77 2.35 0.2 0.6 0.55 1.13 0.92 1.63 0.4 0.57 0.84 1.1 1.22 1.69 0.33 0.55 0.6 1.13 0.79 1.74 0.22 0.8 0.32 1.63 0.21 2.46A5.09 5.09 0 0 1 16.2 16.03c-0.79 1.34-2.14 2.3-3.61 2.77-2.09 0.67-4.48 0.25-6.22-1.09-0.49-0.41-1-0.83-1.31-1.39 0.24 0.04 0.45 0.18 0.68 0.26 1.07 0.35 2.31 0.16 3.18-0.57 0.61-0.48 1.04-1.18 1.19-1.95 0.15-0.7 0.04-1.43-0.16-2.11-0.18-0.65-0.42-1.29-0.56-1.96-0.11-0.62-0.11-1.26 0.02-1.88A4.92 4.92 0 0 1 10.47 5.92Z" />
    </svg>
  )
}

// Real Eitaa brand mark — orange swirl glyph (from public/platforms/eita.svg)
export function IconEitaa({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M6.98 0l10.04 0c3.68 0 6.69 3.01 6.69 6.69l0 3.22c-3.3 1.48-6.63 8.81-11.48 7.22-0.4 0.28-1.32 1.45-1.38 2.34-1.68-0.22-3.62-2.15-3.39-4.22-2.8-2.02-0.49-5.76 1.73-7.26 4.75-3.22 11.35-0.45 7.68 1.85-2.23 1.4-7 2.32-6.51-1.11-1.31 0.38-2.15 2.82-0.57 4.09-1.46 1.43-1.18 4.07 0.39 4.93 1.58-4.09 7.07-3.55 9.29-8.43 1.67-3.67-0.81-7.86-5.76-7.21-3.74 0.49-7.24 3.64-8.99 7.37-1.78 3.79-1.51 8.87 2.14 11.43 4.29 3.01 8.86 0.22 11.63-3.42 1.63-2.15 3.06-4.53 5.22-5.91l0 5.72c0 3.68-3.01 6.7-6.69 6.7l-10.04 0c-3.68 0-6.69-3.01-6.69-6.69l0-10.62c0-3.68 3.01-6.69 6.69-6.69z" />
    </svg>
  )
}

export function IconLinkedIn({ className = 'w-5 h-5' }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      fillRule="evenodd"
      className={className}
      aria-hidden="true"
    >
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  )
}

export function IconTwitter({ className = 'w-5 h-5' }: P) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  )
}
